export const VIEW_MODES = {
	TIMELINE: 'timeline',
	LIST: 'list',
} as const;

export type ViewMode = (typeof VIEW_MODES)[keyof typeof VIEW_MODES];
